import axios from 'axios';
import getAuthToken from '../utils/cookie';

export const getGroupsInCompany = async () => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/group/`;
  const tok = getAuthToken();
  const response = await axios.get(apiUrl, {
    headers: {
      Authorization: `Bearer ${tok}`
    }
  });
  return response;
};

export const createGroupsInCompany = async (group) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/group/`;
  const tok = getAuthToken();
  const response = await axios.post(
    apiUrl,
    { ...group },
    {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    }
  );
  return response;
};

export const updateGroupsInCompany = async (group) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/group/`;
  const tok = getAuthToken();
  const response = await axios.put(
    apiUrl,
    { ...group },
    {
      headers: {
        Authorization: `Bearer ${tok}`
      }
    }
  );
  return response;
};

export const deleteGroupsInCompany = async (group_id) => {
  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}submission/group/`;
  const tok = getAuthToken();
  const response = await axios.delete(apiUrl, {
    headers: {
      Authorization: `Bearer ${tok}`
    },
    data: { _id: group_id }
  });

  return response;
};
